var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDormantIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4074 5.7037C11.4074 8.85377 8.85377 11.4074 5.7037 11.4074C2.55364 11.4074 0 8.85377 0 5.7037C0 2.55364 2.55364 0 5.7037 0C8.85377 0 11.4074 2.55364 11.4074 5.7037Z",
    fill: "#535862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14817 5.70323C8.14817 7.05326 7.05375 8.14768 5.70372 8.14768C4.35369 8.14768 3.25928 7.05326 3.25928 5.70323C3.25928 4.3532 4.35369 3.25879 5.70372 3.25879C7.05375 3.25879 8.14817 4.3532 8.14817 5.70323Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDormantIcon);
export default __webpack_public_path__ + "static/media/DormantIcon.4f66e3d0e871955e66701b934af85a34.svg";
export { ForwardRef as ReactComponent };